import { dcsLogicFbPredicate, dcsSequenceFbPredicate } from './dcs-predicates'
import { strayLabelsCypherExpr } from './stray'

/**
 * Detail bundle for a single DCS node. Dispatches on `labels(n)` so
 * the client issues one round-trip regardless of kind. Every CALL
 * always emits one row (collect/count) so non-applicable kinds
 * collapse to empty lists rather than wiping the outer RETURN.
 *
 * Params: `{ nodeId: string }`.
 */
export const PLANT_DCS_NODE_DETAIL_CYPHER = `
            MATCH (n {id: $nodeId})
              WHERE (n:DcsController OR n:Cee OR n:ControlModule OR n:FunctionBlock
                     OR n:IoModule OR n:IoChannel OR n:ControlTag
                     OR n:ControlAlarm OR n:ControlSetpoint)
            WITH n, labels(n) AS labelList
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:HOSTS]->(c:Cee)
                WHERE 'DcsController' IN labels(n)
              RETURN collect(distinct c) AS controllerCees
            }
            CALL {
              WITH n
              OPTIONAL MATCH (io:IoModule)-[:ASSIGNED_TO|MOUNTED_ON]->(n)
                WHERE 'DcsController' IN labels(n)
              RETURN collect(distinct io) AS controllerIoModules
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(fbDirect:FunctionBlock)
                WHERE 'DcsController' IN labels(n)
              OPTIONAL MATCH (n)-[:HOSTS]->(:Cee)-[:CONTAINS]->(fbViaCee:FunctionBlock)
                WHERE 'DcsController' IN labels(n)
              WITH collect(distinct fbDirect) + collect(distinct fbViaCee) AS raw
              RETURN [fb IN raw WHERE fb IS NOT NULL] AS controllerComms
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:PARTNER_OF]->(p:DcsController)
                WHERE 'DcsController' IN labels(n)
              RETURN collect(p)[0] AS controllerPartner
            }
            CALL {
              WITH n
              OPTIONAL MATCH (mc:Compute)-[:MAPS_TO_CONTROLLER]->(n)
                WHERE 'DcsController' IN labels(n)
              RETURN collect(distinct mc) AS controllerMappedComputes
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)<-[:HOSTS]-(dcs:DcsController)
                WHERE 'Cee' IN labels(n)
              RETURN collect(dcs)[0] AS ceeController
            }
            CALL {
              WITH n
              OPTIONAL MATCH (cm:ControlModule)-[:ASSIGNED_TO]->(n)
                WHERE 'Cee' IN labels(n)
              RETURN collect(distinct cm) AS ceeModules
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(fb:FunctionBlock)
                WHERE 'Cee' IN labels(n)
              RETURN collect(distinct fb) AS ceeComms
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:ASSIGNED_TO]->(cee:Cee)
                WHERE 'ControlModule' IN labels(n)
              OPTIONAL MATCH (cee)<-[:HOSTS]-(dcs:DcsController)
              RETURN collect(cee)[0] AS moduleCee,
                     collect(dcs)[0] AS moduleController
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(fb:FunctionBlock)
                WHERE 'ControlModule' IN labels(n)
                  AND ${dcsLogicFbPredicate('fb')}
              RETURN collect(distinct fb) AS moduleBlocks
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(fb:FunctionBlock)
                WHERE 'ControlModule' IN labels(n)
                  AND ${dcsSequenceFbPredicate('fb')}
              RETURN collect(distinct fb) AS moduleSequence
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:EXPOSES]->(ct:ControlTag)
                WHERE 'ControlModule' IN labels(n)
              RETURN collect(distinct ct) AS moduleTags
            }
            CALL {
              WITH n
              OPTIONAL MATCH (cm:ControlModule)-[:CONTAINS]->(n)
                WHERE 'FunctionBlock' IN labels(n)
              RETURN collect(cm)[0] AS blockModule
            }
            CALL {
              WITH n
              OPTIONAL MATCH (parent:FunctionBlock)-[:CONTAINS]->(n)
                WHERE 'FunctionBlock' IN labels(n)
              RETURN collect(parent)[0] AS blockParent
            }
            CALL {
              WITH n
              OPTIONAL MATCH (cee:Cee)-[:CONTAINS]->(n)
                WHERE 'FunctionBlock' IN labels(n)
              RETURN collect(cee)[0] AS blockCee
            }
            CALL {
              WITH n
              OPTIONAL MATCH (dcs:DcsController)-[:CONTAINS]->(n)
                WHERE 'FunctionBlock' IN labels(n)
              RETURN collect(dcs)[0] AS blockController
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(child:FunctionBlock)
                WHERE 'FunctionBlock' IN labels(n)
              RETURN collect(distinct child) AS blockChildren
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:INSTANTIATES]->(bt:BlockType)
                WHERE 'FunctionBlock' IN labels(n)
              RETURN collect(bt)[0] AS blockType
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:INSTANTIATES]->(:BlockType)-[:DERIVED_FROM]->(parent:BlockType)
                WHERE 'FunctionBlock' IN labels(n)
              RETURN collect(parent)[0] AS blockDerivedFrom
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:INSTANTIATES]->(:BlockType)-[:HAS_PARAM_GROUP]->(g:BlockParamGroup)
                WHERE 'FunctionBlock' IN labels(n)
              RETURN collect(distinct g) AS blockParamGroups
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[r:WIRED_TO|SIGNAL_FLOWS_TO]->(w)
                WHERE 'FunctionBlock' IN labels(n)
                  AND (w:FunctionBlock OR w:IoChannel)
              WITH collect({
                id: w.id,
                name: w.name,
                kind: CASE WHEN w:IoChannel THEN 'IoChannel' ELSE 'FunctionBlock' END,
                from_param: r.from_param,
                to_param: r.to_param,
                from_index: r.from_index,
                to_index: r.to_index,
                role: r.role,
                conn_id: r.conn_id
              }) AS raw
              RETURN [x IN raw WHERE x.id IS NOT NULL] AS blockWiredTo
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:ASSIGNED_TO|MOUNTED_ON]->(dcs:DcsController)
                WHERE 'IoModule' IN labels(n)
              RETURN collect(dcs)[0] AS ioModuleController
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(ch:IoChannel)
                WHERE 'IoModule' IN labels(n)
              RETURN collect(distinct ch) AS ioModuleChannels
            }
            CALL {
              WITH n
              OPTIONAL MATCH (iom:IoModule)-[:CONTAINS]->(n)
                WHERE 'IoChannel' IN labels(n)
              RETURN collect(iom)[0] AS channelModule
            }
            CALL {
              WITH n
              OPTIONAL MATCH (fb:FunctionBlock)-[:WIRED_TO|SIGNAL_FLOWS_TO]->(n)
                WHERE 'IoChannel' IN labels(n)
              RETURN collect(distinct fb) AS channelWiredFrom
            }
            CALL {
              WITH n
              OPTIONAL MATCH (cm:ControlModule)-[:EXPOSES]->(n)
                WHERE 'ControlTag' IN labels(n)
              RETURN collect(cm)[0] AS tagModule
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:HAS_ALARM]->(al:ControlAlarm)
                WHERE 'ControlTag' IN labels(n)
              RETURN collect(distinct al) AS tagAlarms
            }
            CALL {
              WITH n
              OPTIONAL MATCH (sp:ControlSetpoint)-[:SET_BY]->(n)
                WHERE 'ControlTag' IN labels(n)
              RETURN collect(sp)[0] AS tagSetpoint
            }
            CALL {
              WITH n
              OPTIONAL MATCH (ct:ControlTag)-[:HAS_ALARM]->(n)
                WHERE 'ControlAlarm' IN labels(n)
              RETURN collect(ct)[0] AS alarmTag
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:SET_BY]->(ct:ControlTag)
                WHERE 'ControlSetpoint' IN labels(n)
              RETURN collect(ct)[0] AS setpointTag
            }
            RETURN n, labelList,
                   controllerCees, controllerIoModules, controllerComms, controllerPartner, controllerMappedComputes,
                   ceeController, ceeModules, ceeComms,
                   moduleCee, moduleController, moduleBlocks, moduleSequence, moduleTags,
                   blockModule, blockParent, blockCee, blockController, blockChildren,
                   blockType, blockDerivedFrom, blockParamGroups, blockWiredTo,
                   ioModuleController, ioModuleChannels,
                   channelModule, channelWiredFrom,
                   tagModule, tagAlarms, tagSetpoint,
                   alarmTag, setpointTag,
                   ${strayLabelsCypherExpr('n', 'labelList')} AS strayLabels
            LIMIT 10000
          `
